import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Heading, HeadingVariant } from '@vizit/molecules';
import { HomePage } from '../../../../pages';
import { PagesProvider } from '../../../../pages/providers/pages-provider/pages-provider';
import { HOME_BREADCRUMB, beforeLoadAuthenticatedValidation, navigateWithState } from '../../../../router/route-utils';
import { NavbarPageTemplate } from '../../../../templates/navbar-page-template';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/')({
  staticData: {
    pageName: 'Home',
  },
  beforeLoad: async ({ context, location }) => beforeLoadAuthenticatedValidation(context, location),
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const { workspaceSlug } = Route.useParams();

  const handleOnSuccessfulUpload = (assetId: string) => {
    navigateWithState(router, {
      to: '/w/$workspaceSlug/library/assets/$assetId',
      params: { workspaceSlug, assetId },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  const handleOnSuccessfulImport = (pdpId: string) => {
    navigateWithState(router, {
      to: '/w/$workspaceSlug/library/products/$pdpId',
      params: { workspaceSlug, pdpId },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  const handleOnSuccessfulCreate = (pdpId: string) => {
    navigateWithState(router, {
      to: '/w/$workspaceSlug/library/products/$pdpId',
      params: { workspaceSlug, pdpId },
      from: { trail: [HOME_BREADCRUMB] },
      search: (prev: Record<string, unknown>) => ({ ...prev, products: 'open' }),
    });
  };

  const handleOnSuccessfulCollectionCreate = (collectionId: string) => {
    navigateWithState(router, {
      to: '/w/$workspaceSlug/library/collections/$collectionId',
      params: { workspaceSlug, collectionId },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  return (
    <PagesProvider template={NavbarPageTemplate}>
      <div className="flex flex-col gap-8 pt-10 pb-40 pl-8 pr-12 max-sm:px-8 max-sm:py-8">
        <Heading variant={HeadingVariant.H1} className="text-display-md">
          Welcome to Vizit
        </Heading>
        <HomePage
          onSuccessfulUpload={handleOnSuccessfulUpload}
          onSuccessfulImport={handleOnSuccessfulImport}
          onSuccessfulCreate={handleOnSuccessfulCreate}
          onSuccessfulCollectionCreate={handleOnSuccessfulCollectionCreate}
        />
      </div>
    </PagesProvider>
  );
}
